module.exports = __webpack_public_path__ + "0c5614ee8bcb3aefbdffd965cacd6e3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1_variable/public/picture/Canucks_0.jpg
// module id = 400
// module chunks = 0